import React from "react";
import HorizontalBarComp from "./HorizontalBar.component";
import { OrgObjectivesProps} from "../types/orgObjectives.types";
import GoalProgressBar from "../../components/okr/okr_depend_components/goalProgressBar.component";
import HelpTextComp from "../../components/helper/helptext.component";
import { useTranslation } from 'react-i18next';

const OrgObjectivesComp = (props: OrgObjectivesProps) => {
  const { goalData, objKey, plotKeyColorMapping, forData,cQuaterName } = props;
  const { t } = useTranslation();
  return (
    <div className="category-results orgResultsCard">
      <div className="orgResultsCard_header">
        {/* <div className="category-results_header_title">
          Organization Objectives 
        </div> */}
        <div className="orgResultsCard_header_title">
            {
              `${cQuaterName} ${t('Progress as of')} ${props.dateAsOf}`
            }
            {/* <div className="time-left-title-text">
              {`Data as of `}
          </div> */}
        </div>
        <div className="orgResultsCard_header_plotKeyMapping">
          {t('Key')}:
            <div className="plotKey" key={1} title={objKey['okr']}> <div className="key-circle" style={{backgroundColor: plotKeyColorMapping['okr']}}></div><div className="key-text">{objKey['okr']}</div></div>
            <div className="plotKey" key={2} title={objKey['aggregate']}> <div className="key-circle" style={{backgroundColor: plotKeyColorMapping['aggregate']}}></div> <div className="key-text">{objKey['aggregate']}</div></div>

        </div>
      </div>
      <div className="category-results_content">
        {
          goalData && goalData.map((entry, i) => 
            <div className="category-view" key={i}>                    
              <div className="category-view_details">
                <div className="category-view_details_description">
                  {entry.name}
                </div>
                <div className="category-view_details_graph">
                  {   <div>
                        <GoalProgressBar
                        percentage={entry.progress}
                        color={plotKeyColorMapping['okr']}
                        style={{
                          width: "calc(100% - 50px)",
                          marginTop: "0px",
                          fontSize: 12,
                          lineHeight: "12px"
                        }}
                        />  
                      </div>
                      // <HorizontalBarComp
                      // dataInPercentage = {entry.progress}
                      // fill = {plotKeyColorMapping['okr']}
                      // textColor = "rgba(0, 0, 0, 0.54)"
                      // key={1}
                      // type ='okr'
                      // tooltip = {props.renderToolTipData('okr','',null)}
                      // />
                  }
                  {
                      <div> 
                        <GoalProgressBar
                        percentage={entry.gProgress}
                        color={plotKeyColorMapping['aggregate']}
                        title={`${cQuaterName} ${t('progress for')} ${forData.teamName} ${t('and')} ${entry.numOKR} ${t('aligned OKRs')}`}
                        style={{
                          width: "calc(100% - 50px)",
                          marginTop: "0px",
                          fontSize: 12,
                          lineHeight: "12px"
                        }}
                        />  
                      </div>
                      // <HorizontalBarComp
                      // dataInPercentage = {entry.gProgress}
                      // fill = {plotKeyColorMapping['aggregate']}
                      // textColor = "rgba(0, 0, 0, 0.54)"
                      // key={2}
                      // type ='aggregate'
                      // tooltip = {props.renderToolTipData('aggregate',entry.gTitle,entry.numOKR)} //entry.groupName
                      // />
                  }
                </div>
              </div>
            </div>
          )
        }
      </div>
    </div>
  );
}

export default OrgObjectivesComp;

